import React from 'react';
import { FAQ, WEEK, WHY } from './landingCopy';

// Three concise benefits from the approved V3 visual design.
export const WhySection = () => (
  <section className="zl-why" id="waarom" aria-labelledby="why-title">
    <div className="zl-wrap">
      <div className="zl-why-head">
        <p className="zl-eyebrow">{WHY.eyebrow}</p>
        <h2 id="why-title" className="zl-h2">{WHY.title}</h2>
      </div>
      <ol className="zl-why-list">
        {WHY.items.map((item, index) => (
          <li key={item.key} data-testid="why-item">
            <span className="zl-why-index" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
            <h3>{item.benefit}</h3>
            <p>{item.description}</p>
          </li>
        ))}
      </ol>
      <p className="zl-why-note">{WHY.note}</p>
    </div>
  </section>
);

export const WeekSection = ({ onSelectTab }) => (
  <section className="zl-week" id="week" aria-labelledby="week-title">
    <div className="zl-wrap">
      <p className="zl-eyebrow">{WEEK.eyebrow}</p>
      <h2 id="week-title" className="zl-h2 zl-h2-spaced">{WEEK.title}</h2>
      <ol>
        {WEEK.items.map((item) => (
          <li key={item.day} className={item.create ? 'zl-create' : undefined}>
            <p className="zl-eyebrow">{item.day}</p>
            <h3>{item.title}</h3>
            <p>{item.text}</p>
            <button type="button" className="zl-linkbtn" onClick={() => onSelectTab(item.tab, { scroll: true, focus: true })}>{item.link}</button>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export const FaqSection = () => (
  <section className="zl-faq" id="vragen" aria-labelledby="faq-title">
    <div className="zl-wrap">
      <div>
        <p className="zl-eyebrow">{FAQ.eyebrow}</p>
        <h2 id="faq-title" className="zl-h2 zl-h2-spaced">{FAQ.title}</h2>
      </div>
      <div className="zl-faq-list">
        {FAQ.items.map((item) => (
          <details key={item.q}>
            <summary>{item.q}<span className="zl-pm" aria-hidden="true" /></summary>
            <p>{item.a}</p>
          </details>
        ))}
      </div>
    </div>
  </section>
);
